export default {
  baseURL: 'https://api.cellseqexplorer.com/',
  // baseURL: "http://localhost:8000/",
  baseURLensembl: 'https://rest.ensembl.org/',
  baseURLncbi: 'https://eutils.ncbi.nlm.nih.gov/entrez/eutils/',
};
